import { clear } from '../../../helpers/compact';
import { toTextFromProp } from '../fields/text';
import { toBooleanFromProp } from '../fields/boolean';

export const keyFigure = (data) => {
  const figure = toTextFromProp('figure', data);
  if (figure) {
    return clear({
      figure,
      animateFigure: toBooleanFromProp('animate_figure', data, {
        defaultValue: true,
      }),
      title: toTextFromProp('title', data),
      desc: toTextFromProp('desc', data),
    });
  }
};
